import React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";

const StlButton = styled.button`
  border: none;
  background: none;
  display: block;
  margin: auto;
`;

const CookieSettingsLink = () => {
  const dispatch = useDispatch();

  const showCookieSettings = (e) => {
    e.preventDefault();
    dispatch({ type: "COOKIE_COMPLIANCE/SHOW_DETAIL" });
  };

  return (
    <StlButton className="small" onClick={showCookieSettings}>
      Manage Cookie Settings
    </StlButton>
  );
};

export default CookieSettingsLink;
